
import img1 from '@assets/images/element/17.svg';

import { navigateBack, RootState } from '@share/utils';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { ROOMS_UNAVAILABLE_ERROR } from '@constants';

const DashboardHotelBookHero: React.FC<any> = ({ bookingStatus, roomsData }) => {

  const intl = useIntl();

  const { isExternalError, error } = useSelector((state: RootState) => state.reviewBookStore);

  const isRoomUnavaliableError = error === ROOMS_UNAVAILABLE_ERROR;
  const inErrorPage = isExternalError && !isRoomUnavaliableError;

  return (
    <section className="py-0">
      <div className="container">
        {!bookingStatus && (
          <div className="mb-2 pb-2 border-bottom d-flex justify-content-start">
            <button type="button" className="backBtn p-0 btn btn-link" onClick={navigateBack}>
              <FormattedMessage id="back.home" />
            </button>
          </div>)}

        {!inErrorPage && (
          <div className="card bg-light overflow-hidden px-sm-5">
            <div className="row align-items-center g-4">
              <div className="col-sm-9">
                <div className="card-body">
                  <h1 className="m-0 h2 card-title">{`${roomsData === undefined ? intl.formatMessage({ id: 'room.unavailable' }) : bookingStatus ? intl.formatMessage({ id: 'booking.completed' }) : intl.formatMessage({ id: 'review.booking' })}`}</h1>
                </div>
              </div>

              <div className="col-sm-3 text-end d-none d-sm-block">
                <img src={img1} className="mb-n4" alt="" />
              </div>
            </div>
          </div>)}
      </div>
    </section>
  );
};

export default DashboardHotelBookHero;
